import { Selector } from './selector.component';

export * from './selector.component';
export default Selector;

Selector.define('der-ui-selector');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-selector': Selector;
    }
}
